import AttendAchievementOutput from './AttendAchievementOutput';

export default AttendAchievementOutput;
